import { ICourse } from "@core/models/common";

const course1Mock = {
  [ICourse.id]: 65568,
  [ICourse.school]: "HETIC",
  [ICourse.title]: "Expert Développeur front end",
  [ICourse.year]: "2023",
  [ICourse.duration]: {
    id: 5,
    name: "2 ans",
  },
};

const course2Mock = {
  [ICourse.id]: 65569,
  [ICourse.school]: "Aston école",
  [ICourse.title]: "Concepteur dévelopeur",
  [ICourse.year]: "2020",
  [ICourse.duration]: {
    id: 5,
    name: "2 ans",
  },
};

export const coursesMocks = [course1Mock, course2Mock];
